export const selectPromoState = (state) => state.promo;

export const selectIsLoading = (state) => state.promo?.loading || false;

export const selectError = (state) => state.promo?.error || null;

export const selectCoupon = (state) => state.promo?.coupon || null;

export const selectIsApplied = (state) => state.promo?.isApplied || false;

export const selectDiscount = (state) => state.promo?.discount || 0;

export const selectDiscountFormatted = (state) => {
    const discount = state.promo?.discount || 0;
    return discount > 0 ? `${discount.toLocaleString()}₽` : '0₽';
};

export const promoSelectors = {
    selectPromoState,
    selectIsLoading,
    selectError,
    selectCoupon,
    selectIsApplied,
    selectDiscount,
    selectDiscountFormatted,
};

export default promoSelectors;